import Modal from '@/components/modals/modal/modal.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import CurrencyFormatInput from '@/components/currency-format-input/currency-format-input.vue'
import { numberWithSeparator } from '@/utils/format-strings'
import emitHideMixin from '@/components/modals/mixins/emit-hide'

export default {
  name: 'FuelFormModal',
  /**
   * emitHideMixin - методы hide и onHideModal
   */
  mixins: [ emitHideMixin ],
  props: {
    maxAmount: {
      type: Number
    },
    date: {
      type: String | Object
    }
  },
  components: {
    Modal,
    ValidationObserver,
    ValidationProvider,
    CurrencyFormatInput
  },
  data() {
    return {
      form: {
        /**
         * будет отформатированная строка,
         * при помощи регуряного выражения при отправке
         * вытащим из нее число
         */
        amount: 0
      }
    }
  },
  methods: {
    numberWithSeparator,
    show () {
      this.$refs.modal.show()
    },
    onSubmit() {
      this.$refs.observer.validate().then(success => {
        if (success) {
          this.$emit('submit', {
            amount: this.form.amount
          })
          this.$refs.observer.reset()
          this.form.amount = 0
          this.hide()
        }
      })
    }
  }
}